var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
import React, { useEffect } from "react";
import { connect } from '../../store/connect';
import { useParams } from "react-router";
import { useTranslation } from "react-i18next";
import { setAppState } from "../../store/actions";
import { getCmsEntities, getCmsEntitiesData } from "../../store/actions/response.actions";
import { APP_STATE } from "../../store/store";
import { Loader } from "../Loader/Loader";
import { getResponseManager } from "../../responseManager/BeeResponseManager";
import { ReactiveForm } from "../Form";
import { componentMapper, validatorMapper } from "../Form/form-constants";
import { TwoSidedForm } from "../Form/TwoSidedForm/TwoSidedForm";
import { CONSENT_PAGE } from "../../classConstants";
import { LoaderState } from "../../store/actions/loader.actions";
import { API_METHODS_ENUM } from "../../httpService";
import { getBookManager } from "../../models/BookModel";
var CmsFactory = function () {
    var CmsComponent = function (props) {
        var t = useTranslation().t;
        var model_name = props.model_name, model_id = props.model_id;
        var getCmsEntities = props.getCmsEntities, setAppState = props.setAppState, formFields = props.formFields;
        var formValuesRef = React.useRef(props.mergedForm || {});
        useEffect(function () {
            setAppState(APP_STATE.CMS);
        }, []);
        useEffect(function () {
            if (!model_name || !model_id) {
                return;
            }
            ;
            getCmsEntities(model_name, model_id);
        }, [model_name, model_id]);
        if (props.hasErrored)
            return null;
        if (props.isLoading)
            return React.createElement(Loader, null);
        if (formFields.length === 0)
            return null;
        return (React.createElement(React.Fragment, null,
            React.createElement(TwoSidedForm, { className: CONSENT_PAGE, leftSideOnly: true },
                React.createElement(ReactiveForm, { name: props.name, componentMapper: componentMapper, validatorMapper: validatorMapper, initialValues: formValuesRef.current, schema: {
                        fields: __spreadArray([], formFields)
                    } }))));
    };
    var mapStateToProps = function (state) {
        var _a = getCmsEntitiesData(state.responseReducer).response, cmsData = _a === void 0 ? null : _a;
        var name = "cms-data";
        return __assign({ name: name,
            cmsData: cmsData }, new LoaderState(state.loaderReducer, { keys: [API_METHODS_ENUM.GET_CANCEL_BOOKING_ENTITIES] }).status);
    };
    var mergeProps = function (stateProps, dispatchProps, ownProps) {
        var cmsData = stateProps.cmsData, loading = stateProps.loading, loaded = stateProps.loaded, errored = stateProps.errored, form = stateProps.form, loaderState = stateProps.loaderState, restStateProps = __rest(stateProps, ["cmsData", "loading", "loaded", "errored", "form", "loaderState"]);
        var mergedProps = __assign(__assign(__assign(__assign({}, restStateProps), dispatchProps), ownProps), { name: stateProps.name, formFields: [], hasErrored: errored, isLoading: (loading && !loaded), mergedForm: form || {
                form_data: {
                    form_field: {
                        personal_data: []
                    },
                    form_group: {},
                    consent_agreement: {}
                }
            } });
        if (cmsData) {
            var entities = getResponseManager(cmsData).entities();
            if (!entities)
                return mergedProps;
            mergedProps.formFields = getBookManager(entities).getCmsFields(ownProps) || [];
        }
        return mergedProps;
    };
    return connect(mapStateToProps, { setAppState: setAppState, getCmsEntities: getCmsEntities, }, mergeProps)(CmsComponent);
};
export var CmsComponent = CmsFactory();
export var CmsPage = function (props) {
    var _a = useParams(), model_id = _a.model_id, model_name = _a.model_name;
    var componentProps = __assign(__assign({}, props), { model_id: model_id, model_name: model_name });
    return React.createElement(CmsComponent, __assign({}, componentProps));
};
